(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bookids-collaboration"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  if(!event.target.closest('[data-collaboration-link]')) return;
  const option=document.querySelector('#iletisim [data-collaboration-topic]');
  if(option){option.selected=true;option.parentElement.dispatchEvent(new Event('change',{bubbles:true}));}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bookids-gallery"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const panels=[...root.querySelectorAll('[data-panel]')],selectors=[...root.querySelectorAll('[data-character]')],dialog=root.querySelector('dialog');let active=0,index=0,trigger;function thumbs(){return [...panels[active].querySelectorAll('[data-thumb]')]}function selectImage(i){index=i;const t=thumbs()[index],panel=panels[active],img=panel.querySelector('.bk-stage img');img.removeAttribute('srcset');img.src=t.dataset.src;img.alt=t.querySelector('img').alt;panel.querySelector('[data-caption]').textContent=t.dataset.caption;thumbs().forEach((b,n)=>b.setAttribute('aria-pressed',String(n===index)));}function character(i){active=i;panels.forEach((p,n)=>p.hidden=n!==i);selectors.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));index=thumbs().findIndex(t=>t.getAttribute('aria-pressed')==='true');}function render(){const t=thumbs()[index];dialog.querySelector('[data-large]').src=t.dataset.src;dialog.querySelector('[data-large]').alt=t.querySelector('img').alt;dialog.querySelector('[data-light-caption]').textContent=t.querySelector('img').alt;dialog.querySelector('[data-count]').textContent=`${index+1} / ${thumbs().length}`;dialog.querySelector('[data-step="-1"]').disabled=index===0;dialog.querySelector('[data-step="1"]').disabled=index===thumbs().length-1;}function step(n){selectImage(Math.max(0,Math.min(thumbs().length-1,index+n)));render()}root.addEventListener('click',e=>{const ch=e.target.closest('[data-character]');if(ch)character(Number(ch.dataset.character));const th=e.target.closest('[data-thumb]');if(th)selectImage(thumbs().indexOf(th));const en=e.target.closest('[data-enlarge]');if(en){trigger=en;render();dialog.showModal();document.body.classList.add('modal-open')}if(e.target.closest('[data-close]'))dialog.close();const st=e.target.closest('[data-step]');if(st)step(Number(st.dataset.step))});dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();step(1)}if(e.key==='ArrowLeft'){e.preventDefault();step(-1)}});dialog.addEventListener('close',()=>{document.body.classList.remove('modal-open');trigger?.focus()});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});character(0)}document.querySelectorAll('[data-editorial]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-editorial]').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bookids-header"] && !Shopify.designMode) return;
  try {
    
function bookidsNavigationInit(){
 const header=document.querySelector('.bookids-sticky-header');
 if(!header||header.dataset.navigationReady)return;
 header.dataset.navigationReady='true';
 const button=header.querySelector('.bookids-back-top');
 const menu=header.querySelector('.bookids-mobile-menu');
 const update=()=>{header.classList.toggle('is-scrolled',window.scrollY>20);button.hidden=window.scrollY<500;};
 const measure=()=>document.documentElement.style.setProperty('--bookids-header-height',header.offsetHeight+'px');
 const observer=new ResizeObserver(measure);observer.observe(header);measure();update();
 window.addEventListener('scroll',update,{passive:true});
 button.addEventListener('click',()=>{menu.open=false;header.querySelector('header').focus({preventScroll:true});window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});
 menu.addEventListener('click',event=>{if(event.target.closest('a'))menu.open=false;});
 header.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu.open){menu.open=false;menu.querySelector('summary').focus();}});
 document.addEventListener('click',event=>{if(!header.contains(event.target))menu.open=false;});
}
bookidsNavigationInit();
document.addEventListener('shopify:section:load',bookidsNavigationInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
